import React from 'react';
import { UserCheck, Users, Building, ClipboardCheck, Sparkles } from 'lucide-react';

const services = [
  {
    title: 'Gestión y Control de Accesos',
    description: 'Implementamos protocolos rigurosos para la supervisión de entradas y salidas en eventos, obras y complejos corporativos, asegurando un entorno protegido y organizado.',
    icon: UserCheck,
  },
  {
    title: 'Auxiliares Especializados',
    description: 'Personal de apoyo con presencia impecable, expertos en atención al cliente y soporte operativo para dinamizar el funcionamiento de su negocio o evento.',
    icon: Users,
  },
  {
    title: 'Mantenimiento y Limpieza',
    description: 'Soluciones de limpieza técnica y mantenimiento para grandes superficies, locales de ocio y eventos masivos, adaptándonos a la exigencia de cada espacio.',
    icon: Sparkles,
  },
  {
    title: 'Conserjería de Alto Nivel',
    description: 'Servicio exclusivo de portería y gestión de edificios para comunidades de lujo y entornos corporativos, donde la discreción y la eficiencia son nuestra firma.',
    icon: Building,
  },
  {
    title: 'Protocolo y Admisión',
    description: 'Control de admisión especializado bajo normativa vigente. Gestionamos el flujo de asistentes en locales y espectáculos con el máximo rigor y profesionalidad.',
    icon: ClipboardCheck,
  },
];

const Services = () => {
  return (
    <div id="servicios" className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-base text-primary font-semibold tracking-wide uppercase">Nuestros Servicios</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            Soluciones adaptadas a sus necesidades
          </p>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto">
            Ofrecemos un abanico de servicios profesionales diseñados para garantizar el funcionamiento eficiente y seguro de su actividad.
          </p>
        </div>

        <div className="mt-16">
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {services.map((service) => (
              <div key={service.title} className="pt-6">
                <div className="flow-root bg-white rounded-lg px-6 pb-8 shadow-md hover:shadow-xl transition-shadow duration-300 h-full">
                  <div className="-mt-6">
                    <div>
                      <span className="inline-flex items-center justify-center p-3 bg-primary rounded-md shadow-lg">
                        <service.icon className="h-6 w-6 text-white" aria-hidden="true" />
                      </span>
                    </div>
                    <h3 className="mt-8 text-lg font-medium text-gray-900 tracking-tight">{service.title}</h3>
                    <p className="mt-5 text-base text-gray-500">
                      {service.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
